module.exports = __webpack_public_path__ + "static/media/icon_snowman.177060a6.png";